import testUa from './testUa';

const isNaiYou = (): boolean => {
  const r = /(naiyoubz)/gi;
  return testUa(r);
};

export default isNaiYou;
